// extracted by mini-css-extract-plugin
export var text = "_f-0";